module.exports = __webpack_public_path__ + "img/ascend_gold37.a4406cf6.png";